<template>
  <svg
    viewBox="0 0 752 752"
    style="fill: currentColor; height: 1rem; margin: -0.1rem 0.1rem 0.1rem -0.1rem; transform: scale(2)"
  >
    <path d="m541.75 293.12h-236.79v-130.23h-47.359v177.59h331.51v-177.59h-47.359z" />
    <path d="m257.61 589.11h47.359v-130.23h236.79v130.23h47.359v-177.59h-331.51z" />
    <path d="m162.89 288.39v175.22l87.613-87.613z" />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
